<script setup lang="ts">
const goToQuestions = () => {
  const questions = document.querySelector('#faq')
  if (questions) {
    questions.scrollIntoView({ behavior: 'smooth' })
  }
}

const localePath = useLocalePath()
const { request } = useDirectusRest()
const route = useRoute()

const menuItems = [
  {
    label: 'home',
    to: { name: 'index' },
  },
  {
    label: 'prices',
    to: { name: 'prices' },
  },
  {
    label: 'about',
    to: { name: 'about' },
  },
  {
    label: 'faq',
    onClick: goToQuestions,
  },
]

const { data: languages } = await useAsyncData('display-languages', () =>
  request(
    readItems('languages', {
      fields: ['code'],
      sort: ['sort'],
    }),
  ),
)

const { availableLocales, locale, t } = useI18n()
const switchLocalePath = useSwitchLocalePath()
</script>

<template>
  <nav
    class="mx-auto flex w-full max-w-7xl flex-col justify-center px-2 sm:px-10 py-6 lg:flex-row lg:justify-between lg:py-12 2xl:px-0">
    <div class="text-right">
      <CustomerLangSwitcher class="sm:hidden" :languages="languages" />
    </div>
    <NuxtLink :to="localePath({ name: 'index' })"
      class="inline-flex  items-center justify-center gap-4 lg:justify-start">
      <NuxtImg alt="FeestFiets logo" class="h-10 drop-shadow-md md:h-20 " height="80" sizes="40px md:80px"
        :src="`/img/logo.svg`" width="80" />
      <h1>
        <span class="text-3xl font-bold">FeestFiets</span><span class="text-sm font-semibold">.be</span>
      </h1>
    </NuxtLink>
    <div class="inline-flex flex-1 items-center justify-center gap-4 mt-4 lg:mt-0  sm:gap-8 md:gap-16 lg:justify-end">
      <NuxtLink :key="item.label" :to="item.to && localePath(item.to)" @click.passive="item?.onClick"
        active-class="text-sunglow-500" class="link cursor-pointer text-sm font-bold uppercase"
        v-for="item of menuItems">
        {{ t(item.label) }}
      </NuxtLink>
      <CustomerLangSwitcher class="hidden sm:inline-flex" :languages="languages" />
    </div>
  </nav>
</template>

<style lang="css">
.link {
  position: relative;
}

.link::after {
  content: '';
  position: absolute;
  bottom: -2px;
  height: 4px;
  left: 0;
  background-color: currentColor;
  width: 100%;
  transform: scaleX(0);
  transition: transform 0.2s ease-in-out;
  transform-origin: right;
}

.link:hover::after {
  transition: transform 0.2s ease-in-out;
  transform: scaleX(1);
  transform-origin: left;
}
</style>

<i18n lang="json">{
  "en": {
    "about": "About us",
    "faq": "FAQ",
    "prices": "Prices"
  },
  "nl": {
    "about": "Over ons",
    "faq": "Vragen",
    "prices": "Prijzen"
  },
  "fr": {
    "about": "À propos de nous",
    "faq": "FAQ",
    "prices": "Prix"
  }
}</i18n>
